export const GET_RULES_BEGIN = 'GET_RULES_BEGIN'
export const GET_RULES_SUCCESS = 'GET_RULES_SUCCESS'
export const GET_RULES_ERROR = 'GET_RULES_ERROR'

export const CREATE_RULES_BEGIN = 'CREATE_RULES_BEGIN'
export const CREATE_RULES_SUCCESS = 'CREATE_RULES_SUCCESS'
export const CREATE_RULES_ERROR = 'CREATE_RULES_ERROR'

export const UPDATE_RULES_BEGIN = 'UPDATE_RULES_BEGIN'
export const UPDATE_RULES_SUCCESS = 'UPDATE_RULES_SUCCESS'
export const UPDATE_RULES_ERROR = 'UPDATE_RULES_ERROR'

export const DELETE_RULES_BEGIN = 'DELETE_RULES_BEGIN'
export const DELETE_RULES_SUCCESS = 'DELETE_RULES_SUCCESS'
export const DELETE_RULES_ERROR = 'DELETE_RULES_ERROR'